import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

const buttonVariants = {
  primary:
    'bg-primary text-primary-foreground hover:bg-primary-hover focus:ring-2 focus:ring-primary focus:ring-offset-2',
  secondary:
    'bg-surface-elevated text-text-primary border border-border hover:bg-muted-background focus:ring-2 focus:ring-primary focus:ring-offset-2',
  outline:
    'border-2 border-border text-text-primary hover:bg-surface-elevated focus:ring-2 focus:ring-primary focus:ring-offset-2',
  ghost:
    'text-text-primary hover:bg-surface-elevated focus:ring-2 focus:ring-primary focus:ring-offset-2',
  destructive:
    'bg-error text-error-foreground hover:bg-error-hover focus:ring-2 focus:ring-error focus:ring-offset-2',
};

const buttonSizes = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-10 px-4 text-sm',
  lg: 'h-12 px-6 text-base',
};

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled = false,
  className,
  onClick,
  type = 'button',
  leftIcon,
  rightIcon,
  ...props
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      whileHover={!isDisabled ? { scale: 1.02 } : {}}
      whileTap={!isDisabled ? { scale: 0.98 } : {}}
      className={cn(
        'transition-theme inline-flex items-center justify-center gap-2 rounded-lg font-medium',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'focus:outline-none',
        buttonVariants[variant],
        buttonSizes[size],
        className
      )}
      {...props}
    >
      {isLoading ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>Loading...</span>
        </>
      ) : (
        <>
          {leftIcon && <span className="flex-shrink-0">{leftIcon}</span>}
          {children}
          {rightIcon && <span className="flex-shrink-0">{rightIcon}</span>}
        </>
      )}
    </motion.button>
  );
};
